import {PROFILE_SET_LOADING} from "../actions/profileActions";

const INITIAL_STATE = {
    loading: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PROFILE_SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/app/profile/reducers/ProfileFormReducer.js